import { Link } from 'react-router-dom'
import { AlertTriangle } from 'lucide-react'

/**
 * Banniere affichee sur les pages GBP quand le compte Google n'a pas le scope business.manage.
 * La reconnexion elle-meme se fait sur la page Parametres > Connexion Google.
 */
export function GbpReconsentBanner() {
  return (
    <div
      role="alert"
      className="bg-amber-50 dark:bg-amber-950/30 border border-amber-300 dark:border-amber-700 rounded-lg p-4 mb-4 flex items-center justify-between gap-4"
    >
      <div className="flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" strokeWidth={1.75} />
        <div>
          <p className="font-semibold text-amber-900 dark:text-amber-200">
            Accès Google Business Profile non autorisé
          </p>
          <p className="text-sm text-amber-800 dark:text-amber-300">
            Le compte Google connecté n’a pas accordé l’autorisation « Fiches Google Business
            Profile ». Les avis, publications et statistiques ne peuvent pas être synchronisés tant
            que le compte n’est pas reconnecté.
          </p>
        </div>
      </div>
      <Link
        to="/settings/google-account"
        className="bg-amber-600 hover:bg-amber-700 text-white px-4 py-2 rounded-lg text-sm font-medium shrink-0"
      >
        Reconnecter mon compte Google
      </Link>
    </div>
  )
}
